import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	expandPlayerLabel: {
		id: 'audioPlayer.expandPlayerLabel',
		defaultMessage: 'Expand audio player to fullscreen',
		description: 'Indicates to a screen reader what this button does',
	},
});
